export default __webpack_public_path__ + "static/overview4-65bf6fc10002e06f1ed91e8405f5f753.jpg";